const CommonConst = {
    Truck: "truck",
    Trailer: "trailer",
    Driver: "driver",
    Chassis: "chassis",
    Container: "container",
    Various: "various",
    VEHICLES: "VEHICLES",
    TRAILERS: "TRAILERS",
    DRIVERS: "DRIVERS",
    CHASSIS: "CHASSIS",
    CONTAINERS: "CONTAINERS",
    VARIOUS: "VARIOUS",
    Action: "Action",
    vehicleId: "vehicleId",
    trailerId: "trailerId",
    driverId: "driverId",
    chassisId: "chassisId",
    variousResourceId: "variousResourceId",
    resource: "resource",
    resourceId: "resourceId",
    moveToSubGroupDialog: "MoveToSubGroupDialog",
    Default: "Default",
    selectPlanGrp: "Select Plangroup",
    onEventRightClick: "onEventRightClick",
    SendToOBC: "Send To OBC",
    ExchangeTrailer: "Exchange Trailer",
    SplitTrailer: "Split Trailer",
    InsertShippingLine: "Insert Shipping Line",
    InsertBeginEndAction: "Insert Begin - End Action",
    TransferGoods: "Transfer Goods",
    SplitTrip: "Split Trip",
    MoveToLU: "Move To LU",
    EmailTripSheet: "E-mail Trip Sheet",
    PrintTripSheet: "Print Trip Sheet",
    PrintCMR: "Print CMR",
    ViewECMR: "View E-CMR",
    CreateECMR: "Create E-CMR",
    PrintOutsourceConfirmation: "Print Outsource Confirmation",
    EmailOutsourceConfirmation: "E-mail Outsource Confirmation",
    Report: "Report",
    Regroup: "Regroup",
    PartialtripCard: "Partial Trip Card",
    TripCard: "Trip Card",
    ShipmentCard: "Shipment Card",
    ResourceCard: "All Resources",
    FileCard: "File Card",
    ShowOBCMessages: "Show OBC Messages",
    ShowResourceCard: "Show Resource Card",
    Calculate: "Calculate",
    ManualMode : 'Manual Mode',
    Remark: "Remark",
    AgendaItem: "Agenda Item",
    InstructionWithoutFile: "Instruction Without File",
    Route: "Route",
    PartialTrip: "Partial Trip",
    Movement: "Movement",
    BREAK: "BREAK",
    CLEANING: "CLEANING",
    COUPLE: "COUPLE",
    DEPOSIT: "DEPOSIT",
    DRIVE: "DRIVE",
    DRIVEEMPTY: "DRIVEEMPTY",
    FERRYON: "FERRY ON",
    FERRYOF: "FERRY OFF",
    LOAD: "LOAD",
    LOADDEPOT: "LOADDEPOT",
    UNLOAD: "UNLOAD",
    UNLOADDEPOT: "UNLOADDEPOT",
    PICKUP: "PICKUP",
    UNCOUPLE: "UNCOUPLE",
    HOOKON: "HOOKON",
    HOOKOF: "HOOKOF",
    HOOK_OFF: "HOOK OFF",
    HOOK_ON: "HOOK ON",
    PUT_ON: "PUT ON",
    FUEL: "FUEL",
    fixed:"fixed",
    ColorSelected:"green",
    ColorDefault:"#3b66b0",
    ColorIntersect:"orange",
    ColorDropped:"red",
    isRemark: '2008676',
    isAgendaItem: '2002660',
    Movements: 'movements',
    PartialTrips: 'partialTrips',
    InvalidDate: 'Invalid Date',
    targetClassName : 'mbsc-timeline-row',
    classToAlter : 'css-progress',
};


export { CommonConst };